var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockedreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C9.12778 1 6.71891 3.04615 6.12305 5.78711L8.07812 6.21289C8.48226 4.35385 10.0722 3 12 3C14.2762 3 16 4.72381 16 7V8H6C4.90694 8 4 8.90694 4 10V20C4 21.0931 4.90694 22 6 22H18C19.0931 22 20 21.0931 20 20V10C20 8.90694 19.0931 8 18 8V7C18 3.67619 15.3238 1 12 1ZM6 10H18V20H6V10ZM12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13Z",
    fill: "currentColor"
  })));
}
export default SvgUnlockedreact;